import { http } from "../../services/apiEvaluation/Http.interceptor";
import { RatingQuestion } from "./interfaces/RatingQuestion";
import {ResearchQuestionInterface, PutResearchQuestionInterface} from "./interfaces/ResearchQuestion";
import TypeOriginQuestion from "./interfaces/TypeOriginQuestion";
import ValueSearch from "./interfaces/ValueSearch";

const URL: string = '/usuarios/avaluaciones';

export const getByIdResearchQuestion = (id: string) => {
    return http.get<ResearchQuestionInterface>(`${URL}/researchQuestion/${id}`);
}

export const postResearchQuestion = (assessment: ResearchQuestionInterface) => {
    return http.post<ResearchQuestionInterface>(`${URL}/researchQuestion`, assessment);
}

export const getResearchQuestion = () => {
    return http.get<ResearchQuestionInterface[]>(`${URL}/researchQuestion`);
}

export const putResearchQuestion = (assesment: PutResearchQuestionInterface, id: string) => {
    return http.put<PutResearchQuestionInterface>(`${URL}/researchQuestion/${id}`, assesment);
}

export const postValueSearch = (valueSearch: ValueSearch) => {
    return http.post<ValueSearch>(`${URL}/valuesSearch`, valueSearch);
}

export const getValueSearch = () => {
    return http.get<ValueSearch[]>(`${URL}/valuesSearch`);
}

export const putValueSearch = (valueSearch: ValueSearch) => {
    return http.put<ValueSearch>(`${URL}/valuesSearch/${valueSearch.id}`, valueSearch)
}

export const postTypeOriginQuestion = (typeOriginQuestion: TypeOriginQuestion) => {
    return http.post<TypeOriginQuestion>(`${URL}/typeOriginQuestion`, typeOriginQuestion)
}

export const getTypeOriginQuestion = () => {
    return http.get<TypeOriginQuestion[]>(`${URL}/typeOriginQuestion`);
}

export const putTypeOriginQuestion = (typeOriginQuestion: TypeOriginQuestion) => {
    return http.put<TypeOriginQuestion>(`${URL}/typeOriginQuestion/${typeOriginQuestion.id}`, typeOriginQuestion)
}

export const getRatingQuestions = () => {
    return http.get<RatingQuestion[]>(`${URL}/ratingQuestion`);
}

export const deleteResearchQuestion = (id: string) => {
    return http.delete<string>(`${URL}/researchQuestion/${id}`);
}

export const deleteValueSearch = (id: string) => {
    return http.delete<string>(`${URL}/valuesSearch/${id}`);
}

export const deleteTypeOriginQuestion = (id: string) => {
    return http.delete<string>(`${URL}/typeOriginQuestion/${id}`);
}